import { BackButton } from "_shared/button/BackButton";
import { useSurveyContext } from "./SurveyContext";

export function SurveyBackButton() {
  const { back } = useSurveyContext();
  return <BackButton onClick={back} />;
}
